<script>
import { Line, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

export default {
  name: "EvolutionChart",
  extends: Line,
  mixins: [reactiveProp],
  props: ["options", "chartData"],
  mounted() {
    this.renderChart(this.chartData, {
      ...this.options,
      onClick: this.handleClick
    });
  },
  watch: {
    options() {
      this.renderChart(this.chartData, {
        ...this.options,
        onClick: this.handleClick
      });
    }
  },
  methods: {
    handleClick(point, event) {
      const item = event[0];
      if (item) this.$emit("clicked-item", item._index);
    }
  }
};
</script>
